module.exports = __webpack_public_path__ + "media/images/check-circle-38e8c48c.svg";